<script>
	import Navbar from './Navbar.svelte';
	import ScrollIndicator from './ScrollIndicator.svelte';
	import TokenomicsSection from "./TokenomicsSection.svelte";
	import WelcomeSection from "./WelcomeSection.svelte";
	import BuySection from "./BuySection.svelte";
	import SocialLinks from "./SocialLinks.svelte";
	import SecuritySection from "./SecuritySection.svelte";
	import SocialSection from "./SocialSection.svelte";

	let sections = [
		{ title: 'Welcome'},
		{ title: 'Tokenomics'},
		{ title: 'Buy'},
		{ title: 'Social'},
		{ title: 'Security'},
	];

	let currentSection = 0;
	let windowHeight = window.innerHeight;
	let isScrolling = false;
	let scrollPercentage = 0;

	window.addEventListener('scroll', () => {
		const scrollTop = window.scrollY;
		const docHeight = document.documentElement.scrollHeight - window.innerHeight;
		scrollPercentage = (scrollTop / docHeight) * 100;
	});

	// Handle scroll to update the current section and scroll progress
	function handleScroll() {
		const scrollY = window.scrollY;
		const docHeight = document.documentElement.scrollHeight - window.innerHeight;
		scrollPercentage = (scrollY / docHeight) * 100;
		if (!isScrolling) {
			windowHeight = window.innerHeight;
			currentSection = Math.floor(scrollY / windowHeight);
		}
	}

	function scrollToSection(index) {
		isScrolling = true;
		window.scrollTo({
			top: index * windowHeight,
			behavior: 'smooth'
		});
		currentSection = index;
		setTimeout(() => isScrolling = false, 1000);
	}

	window.addEventListener('scroll', handleScroll);
	window.addEventListener('resize', () => windowHeight = window.innerHeight);
</script>

<style>
	:global(body) {
		--background-color: white;
		--text-color: black;
		--button-bg: #f0f0f0;
		--button-text: #333;
	}

	:global(body.dark-mode) {
		--background-color: #333;
		--text-color: white;
		--button-bg: #333;
		--button-text: #f0f0f0;
	}

	.progress-bar {
		position: fixed;
		top: 0;
		left: 0;
		height: 4px;
		background: #007bff;
		z-index: 9999;
	}

</style>

<Navbar {sections} {currentSection} {scrollToSection} />
<ScrollIndicator {sections} {currentSection} />

<!-- Scroll Progress Bar -->
<div class="progress-bar"></div>

<!-- Sections -->
<div>
	<WelcomeSection />
	<TokenomicsSection/>
	<BuySection/>
	<SocialSection/>
	<SecuritySection/>
	<SocialLinks />
</div>
